import { render } from "./communicationPref.vue?vue&type=template&id=0dc8cc57&scoped=true&ts=true"
import script from "./communicationPref.vue?vue&type=script&lang=ts"
export * from "./communicationPref.vue?vue&type=script&lang=ts"

import "./communicationPref.vue?vue&type=style&index=0&id=0dc8cc57&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc8cc57"],['__file',"src/components/account/communicationPref.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0dc8cc57"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0dc8cc57', __exports__)) {
    api.reload('0dc8cc57', __exports__)
  }
  
  module.hot.accept("./communicationPref.vue?vue&type=template&id=0dc8cc57&scoped=true&ts=true", () => {
    api.rerender('0dc8cc57', render)
  })

}


export default __exports__